// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  max-width: 1400px;
  margin: 0 auto;
  animation: fadeInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Header & Welcome Banner */
.dashboard-header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--border);
}

.welcome-banner {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dashboard-welcome {
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 700;
  color: var(--primary-400);
}

.welcome-banner h2 {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -1px;
  color: var(--gray-900);
  margin: 4px 0;
  line-height: 1.2;
}

.user-role-badge {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 4px 12px;
  border-radius: var(--radius-full);
  background: var(--primary-ultralight);
  color: var(--primary);
  font-size: 12px;
  font-weight: 700;
  border: 1px solid var(--primary-200);
  margin-top: 4px;
}

.dashboard-actions {
  display: flex;
  gap: 12px;
}

/* Clickable Stats Card */
.clickable-card {
  padding: 0 !important;
  overflow: hidden;
}

.card-link-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  text-decoration: none;
  width: 100%;
  height: 100%;
}

.stat-text-link {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  transition: var(--transition);
}

.clickable-card:hover .stat-text-link {
  transform: translateX(4px);
  color: var(--primary-dark);
}

/* Widgets Grid Layout (President) */
.dashboard-widgets-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 24px;
  margin-bottom: 32px;
}

.dashboard-widget-box {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  border-top: 3px solid var(--accent);
  overflow: hidden;
  transition: var(--transition);
}

.dashboard-widget-box:hover {
  box-shadow: var(--shadow);
}

.widget-header {
  padding: 16px 20px;
  background: var(--bg);
  border-bottom: 1px solid var(--border);
}

.widget-header h3 {
  font-size: 15px;
  font-weight: 700;
  color: var(--gray-800);
  margin: 0;
  letter-spacing: -0.2px;
}

.widget-body {
  padding: 20px;
}

.dashboard-widget-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* State Progress Bars */
.state-progress-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 380px;
  overflow-y: auto;
  padding-right: 8px;
}

.state-progress-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.state-progress-label {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 500;
}

.state-name {
  color: var(--gray-700);
  font-weight: 600;
}

.state-count {
  color: var(--text-muted);
}

.progress-bar-container {
  height: 8px;
  background: var(--gray-100);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  border-radius: var(--radius-full);
  background: linear-gradient(90deg, var(--primary) 0%, var(--accent) 100%);
  transition: width 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Status breakdown capsules */
.status-badge-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.status-count-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: var(--gray-50);
  border-radius: var(--radius);
  border: 1px solid var(--border-light);
  font-size: 13px;
  font-weight: 500;
}

.estado-badge-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
}

.status-label {
  flex: 1 1;
  color: var(--gray-700);
}

.status-val {
  font-weight: 700;
  color: var(--gray-900);
  background: var(--white);
  padding: 2px 8px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
}

/* VP list counts */
.vp-counts-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.vp-count-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid var(--border-light);
}

.vp-count-row:last-child {
  border-bottom: none;
}

.vp-name {
  font-weight: 600;
  color: var(--gray-700);
  font-size: 13px;
}

.vp-badge {
  font-size: 11px;
  font-weight: 700;
  background: var(--accent-light);
  color: var(--primary);
  padding: 4px 10px;
  border-radius: var(--radius-full);
}

/* Requerimientos Table Card */
.requerimientos-table-card {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  margin-top: 32px;
}

.table-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  background: var(--bg);
  border-bottom: 1px solid var(--border);
}

.table-card-header h3 {
  font-size: 16px;
  font-weight: 700;
  color: var(--gray-800);
  margin: 0;
}

.table-count-pill {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-muted);
  background: var(--gray-200);
  padding: 4px 12px;
  border-radius: var(--radius-full);
}

/* Table Responsive styling */
.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.table th {
  background: var(--white);
  padding: 14px 24px;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--text-muted);
  border-bottom: 2px solid var(--border);
}

.table td {
  padding: 16px 24px;
  vertical-align: middle;
}

.solicitante-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.fullname {
  font-weight: 600;
  color: var(--gray-800);
}

.cedula {
  font-size: 11px;
  color: var(--text-muted);
}

.vp-gerencia-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.vp-text {
  font-weight: 600;
  color: var(--gray-700);
  font-size: 12px;
}

.gerencia-text {
  font-size: 11px;
  color: var(--text-muted);
}

.font-semibold {
  font-weight: 600;
}

.btn-link-action {
  color: var(--primary);
  text-decoration: none;
  font-weight: 600;
  font-size: 13px;
  transition: var(--transition);
  display: inline-flex;
  align-items: center;
}

.btn-link-action:hover {
  color: var(--primary-dark);
  transform: translateX(2px);
}

/* Empty State */
.empty-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;
}

.empty-state-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-state-container h4 {
  font-size: 18px;
  font-weight: 700;
  color: var(--gray-800);
  margin: 0 0 8px 0;
}

.empty-state-container p {
  font-size: 14px;
  color: var(--text-muted);
  max-width: 400px;
  margin: 0;
}

/* Loading state spinner */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 128px 24px;
  gap: 16px;
  color: var(--text-muted);
  font-size: 15px;
  font-weight: 500;
}

.loader {
  width: 44px;
  height: 44px;
  border: 3.5px solid var(--gray-200);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .dashboard-widgets-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .dashboard-header-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  .welcome-banner h2 {
    font-size: 26px;
  }
}

/* Dark mode overrides for Dashboard */
[data-theme="dark"] .welcome-banner h2,
[data-theme="dark"] .dashboard-welcome {
  color: #ffffff;
}

[data-theme="dark"] .user-role-badge {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
}

[data-theme="dark"] .stat-text-link {
  color: #ffffff;
}

[data-theme="dark"] .clickable-card:hover .stat-text-link {
  color: rgba(255, 255, 255, 0.8);
}

[data-theme="dark"] .btn-link-action {
  color: #60a5fa;
}

[data-theme="dark"] .btn-link-action:hover {
  color: #93c5fd;
}

/* Dark mode overrides for dashboard widgets (President) */
[data-theme="dark"] .widget-header h3 {
  color: #ffffff;
}

[data-theme="dark"] .state-name,
[data-theme="dark"] .vp-name,
[data-theme="dark"] .status-label {
  color: #ffffff;
}

[data-theme="dark"] .progress-bar-container {
  background: var(--bg-subtle);
}

[data-theme="dark"] .status-count-item {
  background: var(--bg-subtle);
  border-color: var(--border);
  color: #ffffff;
}

[data-theme="dark"] .status-val {
  background: var(--bg-card);
  color: #ffffff;
  border-color: var(--border);
}

/* =========================================
   RESPONSIVE DESIGN (Tablets y Móviles)
   Añadido sin romper el diseño de escritorio
   ========================================= */

@media (max-width: 768px) {
  .dashboard-actions {
    width: 100%;
    flex-direction: column;
  }
  
  .dashboard-actions .btn {
    width: 100%;
    margin-left: 0 !important;
  }
  
  .table-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .table-pagination-bar {
    flex-direction: column;
    gap: 12px;
  }
  
  .table-pagination-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,sDAAsD;AACxD;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;EACjC,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,yEAAyE;EACzE,oDAAoD;AACtD;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;;8CAG8C;;AAE9C;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".dashboard {\n  max-width: 1400px;\n  margin: 0 auto;\n  animation: fadeInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* Header & Welcome Banner */\n.dashboard-header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 32px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid var(--border);\n}\n\n.welcome-banner {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dashboard-welcome {\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  font-weight: 700;\n  color: var(--primary-400);\n}\n\n.welcome-banner h2 {\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  color: var(--gray-900);\n  margin: 4px 0;\n  line-height: 1.2;\n}\n\n.user-role-badge {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  background: var(--primary-ultralight);\n  color: var(--primary);\n  font-size: 12px;\n  font-weight: 700;\n  border: 1px solid var(--primary-200);\n  margin-top: 4px;\n}\n\n.dashboard-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Clickable Stats Card */\n.clickable-card {\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n.card-link-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n  text-decoration: none;\n  width: 100%;\n  height: 100%;\n}\n\n.stat-text-link {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--primary);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n  transition: var(--transition);\n}\n\n.clickable-card:hover .stat-text-link {\n  transform: translateX(4px);\n  color: var(--primary-dark);\n}\n\n/* Widgets Grid Layout (President) */\n.dashboard-widgets-grid {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.dashboard-widget-box {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n  border-top: 3px solid var(--accent);\n  overflow: hidden;\n  transition: var(--transition);\n}\n\n.dashboard-widget-box:hover {\n  box-shadow: var(--shadow);\n}\n\n.widget-header {\n  padding: 16px 20px;\n  background: var(--bg);\n  border-bottom: 1px solid var(--border);\n}\n\n.widget-header h3 {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin: 0;\n  letter-spacing: -0.2px;\n}\n\n.widget-body {\n  padding: 20px;\n}\n\n.dashboard-widget-column {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* State Progress Bars */\n.state-progress-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-height: 380px;\n  overflow-y: auto;\n  padding-right: 8px;\n}\n\n.state-progress-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.state-progress-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.state-name {\n  color: var(--gray-700);\n  font-weight: 600;\n}\n\n.state-count {\n  color: var(--text-muted);\n}\n\n.progress-bar-container {\n  height: 8px;\n  background: var(--gray-100);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  border-radius: var(--radius-full);\n  background: linear-gradient(90deg, var(--primary) 0%, var(--accent) 100%);\n  transition: width 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* Status breakdown capsules */\n.status-badge-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.status-count-item {\n  display: flex;\n  align-items: center;\n  padding: 10px 14px;\n  background: var(--gray-50);\n  border-radius: var(--radius);\n  border: 1px solid var(--border-light);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.estado-badge-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.status-label {\n  flex: 1;\n  color: var(--gray-700);\n}\n\n.status-val {\n  font-weight: 700;\n  color: var(--gray-900);\n  background: var(--white);\n  padding: 2px 8px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n}\n\n/* VP list counts */\n.vp-counts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.vp-count-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.vp-count-row:last-child {\n  border-bottom: none;\n}\n\n.vp-name {\n  font-weight: 600;\n  color: var(--gray-700);\n  font-size: 13px;\n}\n\n.vp-badge {\n  font-size: 11px;\n  font-weight: 700;\n  background: var(--accent-light);\n  color: var(--primary);\n  padding: 4px 10px;\n  border-radius: var(--radius-full);\n}\n\n/* Requerimientos Table Card */\n.requerimientos-table-card {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  margin-top: 32px;\n}\n\n.table-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 24px;\n  background: var(--bg);\n  border-bottom: 1px solid var(--border);\n}\n\n.table-card-header h3 {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin: 0;\n}\n\n.table-count-pill {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  background: var(--gray-200);\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n}\n\n/* Table Responsive styling */\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.table th {\n  background: var(--white);\n  padding: 14px 24px;\n  text-align: center;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--text-muted);\n  border-bottom: 2px solid var(--border);\n}\n\n.table td {\n  padding: 16px 24px;\n  vertical-align: middle;\n}\n\n.solicitante-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.fullname {\n  font-weight: 600;\n  color: var(--gray-800);\n}\n\n.cedula {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.vp-gerencia-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.vp-text {\n  font-weight: 600;\n  color: var(--gray-700);\n  font-size: 12px;\n}\n\n.gerencia-text {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.btn-link-action {\n  color: var(--primary);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 13px;\n  transition: var(--transition);\n  display: inline-flex;\n  align-items: center;\n}\n\n.btn-link-action:hover {\n  color: var(--primary-dark);\n  transform: translateX(2px);\n}\n\n/* Empty State */\n.empty-state-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  text-align: center;\n}\n\n.empty-state-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.6;\n}\n\n.empty-state-container h4 {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin: 0 0 8px 0;\n}\n\n.empty-state-container p {\n  font-size: 14px;\n  color: var(--text-muted);\n  max-width: 400px;\n  margin: 0;\n}\n\n/* Loading state spinner */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 128px 24px;\n  gap: 16px;\n  color: var(--text-muted);\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.loader {\n  width: 44px;\n  height: 44px;\n  border: 3.5px solid var(--gray-200);\n  border-top-color: var(--primary);\n  border-radius: 50%;\n  animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 992px) {\n  .dashboard-widgets-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-header-container {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n  }\n  .welcome-banner h2 {\n    font-size: 26px;\n  }\n}\n\n/* Dark mode overrides for Dashboard */\n[data-theme=\"dark\"] .welcome-banner h2,\n[data-theme=\"dark\"] .dashboard-welcome {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .user-role-badge {\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.3);\n  background: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme=\"dark\"] .stat-text-link {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .clickable-card:hover .stat-text-link {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n[data-theme=\"dark\"] .btn-link-action {\n  color: #60a5fa;\n}\n\n[data-theme=\"dark\"] .btn-link-action:hover {\n  color: #93c5fd;\n}\n\n/* Dark mode overrides for dashboard widgets (President) */\n[data-theme=\"dark\"] .widget-header h3 {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .state-name,\n[data-theme=\"dark\"] .vp-name,\n[data-theme=\"dark\"] .status-label {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .progress-bar-container {\n  background: var(--bg-subtle);\n}\n\n[data-theme=\"dark\"] .status-count-item {\n  background: var(--bg-subtle);\n  border-color: var(--border);\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .status-val {\n  background: var(--bg-card);\n  color: #ffffff;\n  border-color: var(--border);\n}\n\n/* =========================================\n   RESPONSIVE DESIGN (Tablets y Móviles)\n   Añadido sin romper el diseño de escritorio\n   ========================================= */\n\n@media (max-width: 768px) {\n  .dashboard-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n  \n  .dashboard-actions .btn {\n    width: 100%;\n    margin-left: 0 !important;\n  }\n  \n  .table-card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .table-pagination-bar {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .table-pagination-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
